<template>
  <v-dialog class="the-app-dialogs" v-model="editDialog" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Edit Raw Material Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 class="pb-2 px-2">
                <v-text-field
                  v-model="rawMaterialInfo.product_name"
                  :label="`${$t('Raw Material Name')} *`"
                  name="product_name"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs6 class="pa-2">
                <v-text-field
                  v-model="rawMaterialInfo.product_barcode"
                  :label="`${$t('Barcode')} *`"
                  name="product_barcode"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_barcode')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs6 class="pt-2 px-2">
                <v-text-field
                  v-model="rawMaterialInfo.product_sale"
                  :label="`${$t('Sale Price')} (${systemCurrency}) *`"
                  name="product_sale"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_sale')"
                  v-validate="'required|decimal:3|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs11 :class="{ xs12: !hasPermissions(['product_types_store']) }" class="pa-2">
                <v-autocomplete
                  v-model="rawMaterialInfo.product_type_id_fk"
                  :items="fullProductTypesList"
                  :label="`${$t('Raw Material Type')}`"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_type')"
                  data-vv-name="product_type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 class="pt-2" v-if="hasPermissions(['product_types_store'])">
                <v-tooltip top>
                  <v-btn label @click="$emit('add-product-type')" slot="activator" icon fab small color="green">
                    <v-icon color="white" size="25">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new raw material type') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6 class="pa-2">
                <v-text-field
                  v-model="rawMaterialInfo.quantity_alarm"
                  :label="$t('Quantity Alarm')"
                  name="quantity_alarm"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('quantity_alarm')"
                  v-validate="'integer'"
                />
              </v-flex>

              <v-flex xs6 class="pt-2 px-2">
                <v-text-field
                  v-model="rawMaterialInfo.quantity_alarm_total"
                  :label="$t('Total Quantity Alarm')"
                  name="quantity_alarm_total"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('quantity_alarm_total')"
                  v-validate="'integer'"
                />
              </v-flex>

              <!-- <v-flex xs12 class="pa-2">
                <v-text-field
                  v-model="rawMaterialInfo.expire_alarm"
                  :label="$t('Expiration Alarm (No. of days before expiration date)')"
                  name="expire_alarm"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('expire_alarm')"
                  v-validate="'integer'"
                />
              </v-flex>-->

              <v-flex xs6 class="px-2" style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBeSold"
                  :label="$t('Raw Material Can Be Sold')"
                  name="can_be_sold"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_sold')"
                />
              </v-flex>

              <v-flex xs6 class="px-2" style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBePurchase"
                  :label="$t('Raw Material Can Be Purchase')"
                  name="can_be_purchase"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_purchase')"
                />
              </v-flex>

              <v-flex xs12 class="pa-2">
                <v-textarea
                  v-model="rawMaterialInfo.product_description"
                  :label="$t('Description')"
                  name="product_description"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('product_description')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      form: {
        canBeSold: null,
        canBePurchase: null
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      rawMaterialInfo: 'rawMaterials/getRawMaterialInfo',
      fullProductTypesList: 'productTypes/getFullProductTypesList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()

          let CBS = this.rawMaterialInfo.can_be_sold.toString()
          let CBP = this.rawMaterialInfo.can_be_purchase.toString()
          this.form.canBeSold = CBS === '1' ? '1' : '0'
          this.form.canBePurchase = CBP === '1' ? '1' : '0'
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateRawMaterialInfo: 'rawMaterials/updateRawMaterialInfo'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    removeTag(item) {
      this.form.tags.splice(this.form.tags.indexOf(item), 1)
      this.form.tags = [...this.form.tags]
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('can_be_sold', this.form.canBeSold || '')
          formData.append('can_be_purchase', this.form.canBePurchase || '')
          formData.append('product_type_id_fk', this.rawMaterialInfo.product_type_id_fk || '')

          let payload = { id: this.rawMaterialInfo.product_id, formData }

          this.updateRawMaterialInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
